import ApplePay from 'features/moveMoney/screens/ApplePay/ApplePay';

export default ApplePay;
